import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { USER_TYPES } from '@fttb/common';
import { getSharedData } from "../selectors";
export var getBreadcrumbsData = function getBreadcrumbsData(state) {
  return getSharedData(state).breadcrumbs;
};
export var getCallbackRequestData = function getCallbackRequestData(state) {
  return getSharedData(state).callbackRequestData;
};
export var getCallbackRequestTexts = function getCallbackRequestTexts(state) {
  return getCallbackRequestData(state).texts || emptyObj;
};
export var getPageSettings = function getPageSettings(state) {
  return getSharedData(state).pageSettings || emptyObj;
};
export var getSelfCallingPopupData = function getSelfCallingPopupData(state) {
  return getSharedData(state).selfCallingPopupData;
};
export var getUserData = function getUserData(state) {
  return getSharedData(state).userData || emptyObj;
};
export var getPageType = function getPageType(state) {
  return getPageSettings(state).pageType;
};
export var getActiveCtn = function getActiveCtn(state) {
  return getUserData(state).activeCTN || '';
};
export var getUserType = function getUserType(state) {
  return getUserData(state).userType;
};
export var getIsAuthFlag = function getIsAuthFlag(state) {
  return getPageSettings(state).isAuth;
};
export var isUserFttb = createSelector([getUserType], function (type) {
  return type === USER_TYPES.FTTB_USER;
});
export var isUserFms = createSelector([getUserType], function (type) {
  return type === USER_TYPES.FMS_USER;
});